import { render } from "./Admin.vue?vue&type=template&id=0515c322"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=0515c322&lang=scss"

import exportComponent from "/Users/chrisrooster/Documents/Sites/mycelium/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__